export function toImageBase64(url) {
  const pages = [];
  const heights = [];
  let width = 0;
  let height = 0;
  let currentPage = 1;
  const scale = 1.5;

  function draw() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    for (let i = 0; i < pages.length; i++) ctx.putImageData(pages[i], 0, heights[i]);
    return canvas.toDataURL();
  }

  const pdfjsLib = window['pdfjs-dist/build/pdf'];

  if (!pdfjsLib) {
    throw new Error('PDF lib was not registered');
  }

  pdfjsLib.disableWorker = true; // due to CORS
  const loadingTask = pdfjsLib.getDocument(url);

  return loadingTask.promise.then(pdf => {
    function getPage() {
      return pdf.getPage(currentPage).then(page => {
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const renderContext = { canvasContext: ctx, viewport };

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        return page.render(renderContext).promise.then(() => {
          pages.push(ctx.getImageData(0, 0, canvas.width, canvas.height));

          heights.push(height);
          height += canvas.height;
          if (width < canvas.width) width = canvas.width;

          if (currentPage < pdf.numPages) {
            currentPage++;
            return getPage();
          }
          return draw();
        });
      });
    }
    return getPage();
  });
}
